export default __webpack_public_path__ + "static/media/VMLY&R_Logo3.242ad693.png";